<template>
   <div>
     <apexchart ref="myChart" width="100%" :height="this.height ? this.height : 320" type="line" :options="chartOptions" :series="series"></apexchart>
   </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default {
    props:['categories', 'chartdata', 'ycolor', 'xcolor', 'height'],
    data: function() {
      return {
        chartOptions: {
            chart: {
                height: this.height ? this.height : 350,
                id: 'linechart',
                toolbar: {
                    show: false,
                    tools:{
                        download:false // <== line to add
                    }
                },
                zoom: {
                    enabled: false
                },
                animations: {
                    enabled: false
                },
                type: 'line',
            },
            // dataLabels: {
            //   enabled: true,
            //   formatter: (val) => {
            //     // let newVal = this.labeldecimals ? parseInt(val) : val.toFixed(2);
            //     return this.numberWithCommas(val);
            //   }
            // },
            yaxis: {
                categories: this.categories,
                labels: {
                    style: {
                        colors: this.ycolor ? this.ycolor : '#FFF'
                    },
                    formatter: (val) => {
                        // let newVal = this.labeldecimals ? parseInt(val) : val.toFixed(2);
                        return this.numberWithCommas(val);
                    }
                }
            },
            xaxis: {
                categories: this.categories,
                labels: {
                    style: {
                        colors: this.xcolor ? this.xcolor : '#FFF'
                    }
                }
            },
            colors: ["#0cbcf2", "#003565", "#7041e5", "#b8c3d0", "#beaeff"]
        },
        series: this.chartdata
        // series: [{
        //   name: 'series-1',
        //   data: this.chartdata
        // }],
      }
    },
    methods: {
      numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            } else {
                return x;
            }
        },
    },
    watch: {
        categories: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        },
        series: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        }
    }
};
</script>